import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _dec, _class, _class2, _temp, _class2$defaultProps;

import React from 'react';
import { func, number } from 'prop-types';
import { isKeyArrowLeft, isKeyArrowRight, isKeyEnter } from "../../../lib/events/keyboard/identifiers";
import { locale } from "../../../lib/locale/decorators";
import { tabListener } from "../../../lib/events/tabListener";
import { emptyHandler } from "../../../lib/utils";
import { isIE11 } from "../../../lib/client";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { ArrowChevronRightIcon } from "../../../internal/icons/16px";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Paging.styles";
import * as NavigationHelper from "../NavigationHelper";
import { getItems } from "../PagingHelper";
import { PagingLocaleHelper } from "../locale";
var IGNORE_EVENT_TAGS = ['input', 'textarea'];
export var Paging = (_dec = locale('Paging', PagingLocaleHelper), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Paging, _React$Component);

  function Paging() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focusedByTab: false,
      focusedItem: null,
      keyboardControl: _this.props.useGlobalListener
    };
    _this.theme = void 0;
    _this.locale = void 0;
    _this.addedGlobalListener = false;
    _this.container = null;

    _this.renderItem = function (item, index) {
      var focused = _this.getFocusedItem() === item;

      switch (item) {
        case '.':
          {
            var key = "dots" + (index < 5 ? 'Left' : 'Right');
            return _this.renderDots(key);
          }

        case 'forward':
          {
            var disabled = _this.isItemDisabled(item);

            return _this.renderForwardLink(disabled, focused);
          }

        default:
          {
            var active = _this.props.activePage === item;
            return _this.renderPageLink(item, active, focused);
          }
      }
    };

    _this.renderDots = function (key) {
      return /*#__PURE__*/React.createElement("span", {
        "data-tid": "Paging__dots",
        key: key,
        className: styles.dots(_this.theme)
      }, '...');
    };

    _this.renderForwardLink = function (disabled, focused) {
      var _cx;

      var classes = cx((_cx = {}, _cx[styles.forwardLink(_this.theme)] = true, _cx[styles.forwardLinkFocused()] = focused, _cx[styles.disabled(_this.theme)] = disabled, _cx));
      var _this$props = _this.props,
          Component = _this$props.component,
          caption = _this$props.caption;
      var forward = _this.locale.forward;
      return /*#__PURE__*/React.createElement(Component, {
        key: 'forward',
        "data-tid": "Paging__forwardLink",
        active: false,
        className: classes,
        onClick: disabled ? emptyHandler : _this.goForward,
        tabIndex: -1,
        pageNumber: 'forward'
      }, caption || forward, /*#__PURE__*/React.createElement("span", {
        className: styles.forwardIcon(_this.theme)
      }, /*#__PURE__*/React.createElement(ArrowChevronRightIcon, {
        size: _this.theme.pagingForwardIconSize
      })));
    };

    _this.renderPageLink = function (pageNumber, active, focused) {
      var _cx2;

      var classes = cx((_cx2 = {}, _cx2[styles.pageLink(_this.theme)] = true, _cx2[styles.pageLinkFocused(_this.theme)] = focused, _cx2[styles.active(_this.theme)] = active, _cx2));
      var Component = _this.props.component;

      var handleClick = function handleClick() {
        return _this.goToPage(pageNumber);
      };

      return /*#__PURE__*/React.createElement("span", {
        "data-tid": "Paging__pageLinkWrapper",
        key: pageNumber,
        className: styles.pageLinkWrapper(),
        onMouseDown: _this.handleMouseDownPageLink
      }, /*#__PURE__*/React.createElement(Component, {
        "data-tid": "Paging__pageLink",
        active: active,
        className: classes,
        onClick: handleClick,
        tabIndex: -1,
        pageNumber: pageNumber
      }, pageNumber), active && _this.renderNavigationHint());
    };

    _this.renderNavigationHint = function () {
      if (_this.props.withoutNavigationHint) {
        return null;
      }

      var keyboardControl = _this.state.keyboardControl;

      var canGoBackward = _this.canGoBackward();

      var canGoForward = _this.canGoForward();

      if (keyboardControl && (canGoBackward || canGoForward)) {
        return /*#__PURE__*/React.createElement("span", {
          className: styles.pageLinkHint(_this.theme)
        }, /*#__PURE__*/React.createElement("span", {
          className: canGoBackward ? '' : styles.transparent()
        }, '←'), /*#__PURE__*/React.createElement("span", null, NavigationHelper.getKeyName()), /*#__PURE__*/React.createElement("span", {
          className: canGoForward ? '' : styles.transparent()
        }, '→'));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.pageLinkHintPlaceHolder(_this.theme)
      });
    };

    _this.handleMouseDown = function () {
      _this.setState({
        focusedByTab: false,
        focusedItem: null
      });
    };

    _this.handleMouseDownPageLink = function () {
      if (isIE11) {
        // Клик по span внутри контейнера с tabindex="0" переносит фокус именно на этот span.
        // Поэтому горячие клавиши работают пока span существует на странице.
        setTimeout(function () {
          return _this.container && _this.container.focus();
        }, 0);
      }
    };

    _this.handleKeyDown = function (e) {
      if (e.shiftKey) {
        return;
      }

      var target = e.target;
      var isArrowLeft = isKeyArrowLeft(e);
      var isArrowRight = isKeyArrowRight(e);

      if (target instanceof Element && (IGNORE_EVENT_TAGS.includes(target.tagName.toLowerCase()) || target.isContentEditable)) {
        return;
      }

      if (NavigationHelper.checkKeyPressed(e) && isArrowLeft) {
        _this.setState({
          focusedItem: null
        }, _this.goBackward);

        return;
      }

      if (NavigationHelper.checkKeyPressed(e) && isArrowRight) {
        _this.setState({
          focusedItem: null
        }, _this.goForward);

        return;
      }

      if (_this.container && _this.container === e.target) {
        if (isArrowLeft) {
          _this.setState({
            focusedByTab: true
          }, _this.moveFocusLeft);

          return;
        }

        if (isArrowRight) {
          _this.setState({
            focusedByTab: true
          }, _this.moveFocusRight);

          return;
        }

        if (isKeyEnter(e)) {
          _this.executeItemAction(_this.getFocusedItem());

          return;
        }
      }
    };

    _this.handleFocus = function (e) {
      if (_this.props.disabled) {
        return;
      }

      _this.setState({
        keyboardControl: true
      }); // focus event fires before keyDown eventlistener
      // so we should check tabPressed in async way


      requestAnimationFrame(function () {
        if (tabListener.isTabPressed) {
          _this.setState({
            focusedByTab: true
          });
        }
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        focusedByTab: false,
        keyboardControl: _this.props.useGlobalListener || false
      });
    };

    _this.getItems = function () {
      return getItems(_this.props.activePage, _this.props.pagesCount).concat('forward');
    };

    _this.getFocusedItem = function () {
      if (!_this.state.focusedByTab) {
        return null;
      }

      var focusedItem = _this.state.focusedItem;

      if (focusedItem && _this.getItems().includes(focusedItem) && _this.isItemFocusable(focusedItem)) {
        return focusedItem;
      }

      return _this.props.activePage;
    };

    _this.isItemFocusable = function (item) {
      return !_this.isItemDisabled(item);
    };

    _this.isItemDisabled = function (item) {
      switch (item) {
        case '.':
          return true;

        case 'forward':
          return !_this.canGoForward();

        default:
          return false;
      }
    };

    _this.executeItemAction = function (item) {
      if (item === 'forward') {
        _this.goForward();
      }

      if (typeof item === 'number') {
        _this.goToPage(item);
      }
    };

    _this.moveFocusLeft = function () {
      _this.moveFocus(-1);
    };

    _this.moveFocusRight = function () {
      _this.moveFocus(1);
    };

    _this.moveFocus = function (step) {
      var focusedItem = _this.getFocusedItem();

      var items = _this.getItems();

      var index = items.findIndex(function (x) {
        return x === focusedItem;
      });

      do {
        index = (index + step + items.length) % items.length;
      } while (!_this.isItemFocusable(items[index]));

      _this.setState({
        focusedItem: items[index]
      });
    };

    _this.canGoBackward = function () {
      return _this.props.activePage > 1;
    };

    _this.canGoForward = function () {
      return _this.props.activePage < _this.props.pagesCount;
    };

    _this.goBackward = function () {
      _this.goToPage(_this.props.activePage - 1);
    };

    _this.goForward = function () {
      _this.goToPage(_this.props.activePage + 1);
    };

    _this.goToPage = function (pageNumber) {
      if (1 <= pageNumber && pageNumber !== _this.props.activePage && pageNumber <= _this.props.pagesCount) {
        _this.props.onPageChange(pageNumber);
      }
    };

    _this.addGlobalListener = function () {
      if (_this.addedGlobalListener) {
        return;
      }

      document.addEventListener('keydown', _this.handleKeyDown);
      _this.addedGlobalListener = true;
    };

    _this.removeGlobalListener = function () {
      if (_this.addedGlobalListener) {
        document.removeEventListener('keydown', _this.handleKeyDown);
        _this.addedGlobalListener = false;
      }
    };

    _this.refContainer = function (element) {
      _this.container = element;
    };

    return _this;
  }

  Paging.isForward = function isForward(pageNumber)
  /* %checks */
  {
    return pageNumber === 'forward';
  };

  var _proto = Paging.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var useGlobalListener = this.props.useGlobalListener;

    if (useGlobalListener) {
      this.addGlobalListener();
    }
  };

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.useGlobalListener !== nextProps.useGlobalListener) {
      this.setState({
        keyboardControl: nextProps.useGlobalListener
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!prevProps.useGlobalListener && this.props.useGlobalListener) {
      this.addGlobalListener();
    }

    if (prevProps.useGlobalListener && !this.props.useGlobalListener) {
      this.removeGlobalListener();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeGlobalListener();
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("span", {
      tabIndex: 0,
      "data-tid": this.props['data-tid'],
      className: styles.paging(this.theme),
      onKeyDown: this.props.useGlobalListener ? undefined : this.handleKeyDown,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onMouseDown: this.handleMouseDown,
      ref: this.refContainer
    }, this.getItems().map(this.renderItem)));
  };

  return Paging;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Paging', _class2.defaultProps = (_class2$defaultProps = {
  component: function component(_ref) {
    var className = _ref.className,
        onClick = _ref.onClick,
        children = _ref.children;
    return /*#__PURE__*/React.createElement("span", {
      className: className,
      onClick: onClick
    }, children);
  },
  useGlobalListener: false
}, _class2$defaultProps['data-tid'] = 'Paging__root', _class2$defaultProps), _class2.propTypes = {}, _temp)) || _class);
Paging.propTypes = {
  /**
   * Current active page
   */
  activePage: number.isRequired,

  /**
   * React component that would be used for rendering items
   *
   * Usefull for router integration
   */
  component: func,

  /**
   * Total page count
   */
  pagesCount: number.isRequired,

  /**
   * Calls when page has been changed
   */
  onPageChange: func.isRequired
};